// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__gZS35","active":"Pagination_active__6+ULY","pageNumber":"Pagination_pageNumber__5w6w3","arrow":"Pagination_arrow__Sp8ti"};